import angular from 'angular';
import duration from './duration';
import dateTimePicker from './date-time-picker';
import workingTimings from './working-timings';
import dateTimeView from './date-time-view';
import boolView from './bool-view';
import multipleSelect from './multiple-select';
import notFoundPage from './not-found-page';
import singleSelect from './single-select';
import dayOverrides from './day-overrides';
import userDisplay from './user-display';
import issueTags from './issue-tags';
import projectSelector from './project-selector';

const widgets = angular.module('ttb.widgets', [
  duration,
  dateTimePicker,
  workingTimings,
  dateTimeView,
  boolView,
  multipleSelect,
  notFoundPage,
  singleSelect,
  dayOverrides,
  userDisplay,
  issueTags,
  projectSelector,
])
  .name;

export default widgets;



// WEBPACK FOOTER //
// ../widgets/index.js